export default function CheckIcon({ size = 32, color = "", ...props }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M43.6022 20C44.5156 24.4826 43.8646 29.1428 41.7579 33.2036C39.6512 37.2643 36.216 40.4801 32.0252 42.3146C27.8345 44.1491 23.1415 44.4915 18.7288 43.2847C14.3161 42.0779 10.4506 39.3948 7.77675 35.6828C5.10292 31.9709 3.78244 27.4545 4.03553 22.8868C4.28861 18.319 6.09996 13.9762 9.1675 10.5823C12.235 7.18848 16.3734 4.94884 20.8923 4.23689C25.4113 3.52493 30.0378 4.3837 34.0002 6.66998"
        stroke={color}
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 22L24 28L44 8"
        stroke={color}
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
